<div class="topbar-container">
  <div class="logo">
    <span nz-icon nzType="smile" nzTheme="outline"></span>
    <span class="title">Oncoscope CRM</span>
  </div>

  <nav class="menu-container">
    @for (item of menuItems; track item.route) {
    <a
      class="menu-item"
      [routerLink]="item.disabled ? null : item.route"
      routerLinkActive="selected"
      [routerLinkActiveOptions]="{ exact: item.exact }"
      [class.disabled]="item.disabled"
    >
      {{ item.label }}
    </a>
    }
  </nav>

  <div class="actions-container">
    <button nz-button nzType="text" nzShape="circle" (click)="toggleTheme()">
      <span nz-icon [nzType]="themeService.isDarkMode() ? 'sun' : 'moon'" nzTheme="outline"></span>
    </button>

    <button nz-button nzType="text" nzShape="circle" (click)="refresh()">
      <span nz-icon nzType="reload" nzTheme="outline"></span>
    </button>

    <div class="username" nz-dropdown [nzDropdownMenu]="userMenu">{{ userService.username[0] | uppercase }}</div>
    <nz-dropdown-menu #userMenu="nzDropdownMenu">
      <ul nz-menu nzSelectable>
        <li nz-menu-item>{{ userService.username }}</li>
        <li nz-menu-item>
          <span (click)="logout()" aria-hidden="true">
            <span class="logout-icon" nz-icon nzType="logout" nzTheme="outline"></span>
            Sign out
          </span>
        </li>
      </ul>
    </nz-dropdown-menu>
  </div>
</div>
